import { useEffect, useState } from 'react';

import ArrowUpIconSvg from 'public/icons/ArrowUp.svg';

import { Button } from '../_Button/Button';

import styles from './BackToTop.module.css';

export default function BackToTop(): JSX.Element {
	const [showButton, setShowButton] = useState(false);

	useEffect(() => {
		function scrollHandler() {
			setShowButton(window.scrollY > 20 ? true : false);
		}

		window.addEventListener('scroll', scrollHandler);

		return () => window.removeEventListener('scroll', scrollHandler);
	}, []);

	return (
		<div className={`${styles.buttonWrapper} ${showButton ? 'active' : ''}`}>
			<Button
				title="Back to Top"
				className={styles.button}
				onClick={() => {
					window.scrollTo({
						top: 0,
						left: 0,
						behavior: 'smooth',
					});
				}}
			>
				<ArrowUpIconSvg />
			</Button>
		</div>
	);
}
